import { render } from "./SSBTStatus.vue?vue&type=template&id=76d5c974"
import script from "./SSBTStatus.vue?vue&type=script&lang=js"
export * from "./SSBTStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__